import React from 'react'
import { useNavigate } from 'react-router-dom'
import avatar from '../../assets/images/avatar.webp'

const HomeBanner = () => {
    const navigation = useNavigate()
    return (
        <div className='home-banner overflow-hidden ' >
            <div className='pt-5'>
                <h1 className='banner-heading mb-4 arial-bold' data-aos="zoom-out-up" data-aos-duration="1500">Become an AI Powered Digital Entrepreneur</h1>
                <h5 className='banner-sub-heading mb-5 arial-regular' data-aos="zoom-out-up" data-aos-duration="1500">Learn AI Powered Digital Marketing from industry Experts who<br className='break-tag' /> Practice what they Teach everyday</h5>
                <div className='flexRow'>
                    <a href="https://optin.socialeagle.in/#/apply" data-aos="fade-right" data-aos-duration="1500" target='_blank'>
                        <button type="button" class="btn btn-book-expert-call arial-bold">Book Expert Call</button>
                    </a>
                    <button onClick={() => navigation('Course')} data-aos="fade-left" data-aos-duration="1500" type="button " class="btn btn-explore-course arial-bold">Explore Course</button>
                </div>
                <div className='mt-4'>
                    <img
                        width="100" height="100"
                        className="circle-center-face-img"
                        loading="lazy"
                        src={avatar}
                        alt="Tick"
                    />
                    <p className='banner-sub-heading mt-2 arial-regular'>
                        Join the 1800+ who've already transformed their lives
                    </p>
                </div>
            </div>

        </div>
    )
}

export default HomeBanner